export default __webpack_public_path__ + "static/media/odyssey-logo.1c8de59c.svg";